import React, { useState } from 'react'
import { Collapse, Box } from '@mui/material'
import SanitizeHtml from '../../Base/SanitizeHtml/SanitizeHtml'
import { useSelector } from 'react-redux'
import * as lib from '../../../../js/lib/lib'

const Extra = ({
  amenity,
  dictionary,
  onAddExtra,
  onRemoveExtra,
  isLoading,
}) => {
  // const { dictionary } = window.bookingData || window.modifyData
  const [showMore, setShowMore] = useState(false)
  const { selectedExtras } = useSelector((state) => state.booking)

  const isSelected = () => {
    const selected = selectedExtras.map((i) => i.code)
    return selected.includes(amenity.code)
  }

  const toggleContent = () => {
    setShowMore(!showMore)
  }

  const handleAddExtra = () => {
    const radioInputs = document.getElementsByName(amenity.code)
    const selectedQuantity =
      radioInputs.length > 0
        ? Array.from(radioInputs).find((input) => input.checked)?.value
        : '1'

    onAddExtra(amenity.code, selectedQuantity)
  }

  const handleRemoveExtra = () => {
    onRemoveExtra(amenity.code)
  }

  return (
    <div className="b-extra">
      {amenity.image && (
        <img
          className="b-extra__icon"
          src={amenity.image.url}
          alt={amenity.image.alt}></img>
      )}

      <div className="b-extra__content">
        <div className="b-extra__content__line">
          <div className="b-extra__title">
            {amenity.image && (
              <img
                className="b-extra__title__icon"
                src={amenity.image.url}
                alt={amenity.image.alt}></img>
            )}
            {amenity.name}
          </div>
          {amenity.summary && (
            <div
              className={`b-extra__more ${showMore ? 'show' : ''}`}
              onClick={toggleContent}>
              {dictionary.extraLearnMoreLabel}
              <i className="icon-arrow-down arrow" />
            </div>
          )}
        </div>
        <div className="b-extra__content__line">
          <Collapse in={showMore}>
            <Box className="b-extra__more__content">
              <SanitizeHtml html={amenity.summary} />
            </Box>
          </Collapse>
        </div>
        {amenity.maxQuantity > 1 && !isSelected() && (
          <div className="b-extra__content__line">
            <div className="b-extra__quantity">
              <span>{amenity.quantityLabel}</span>
              <div className="b-extra__quantity__radio">
                {[...Array(amenity.maxQuantity).keys()].map((i) => (
                  <div className="b-extra__quantity__radio__pair" key={i + 1}>
                    <input
                      type="radio"
                      id={`radio-${amenity.code}-${i + 1}`}
                      name={amenity.code}
                      value={i + 1}
                      defaultChecked={i === 0}
                    />
                    <label htmlFor={`radio-${amenity.code}-${i + 1}`}>
                      {i + 1}
                    </label>
                  </div>
                ))}
              </div>
            </div>
          </div>
        )}
        <div className="b-extra__content__line">
          <div className="b-extra__cost">
            <div className="b-extra__cost__daily">
              {lib.formatCurrency(amenity.currency, amenity.dailyRate)}
              <span className="b-extra__cost__suffix">{dictionary.perDay}</span>
            </div>
            <div className="b-extra__cost__info">
              {amenity.isPrepaid && (
                <span>{dictionary.extraPayOnlineText}</span>
              )}
              {!amenity.isPrepaid && (
                <span>{dictionary.extraPayOnPickUpText}</span>
              )}
            </div>
          </div>
          <button
            type="button"
            className={`btn ${
              isSelected() ? 'btn-outline-primary' : 'btn-primary'
            } b-extra__btn`}
            disabled={isLoading}
            onClick={isSelected() ? handleRemoveExtra : handleAddExtra}>
            {isSelected()
              ? dictionary.buttonExtraRemoveText
              : dictionary.buttonExtraAddText}
          </button>
        </div>
      </div>
    </div>
  )
}

export default Extra
